import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { SubscribeManager } from '../class/subscribe-manager.class';
import { EnvironmentalDataSource } from './types/EnvironmentalDataSource';
import { APIWithLoaderHelper } from '../helpers/apiWithLoaderHelper';
import { URLConstants } from '@app/core/constants/URLConstants';
import { EnvironmentalDataSourceDashGroupsService } from './environmentalDataSourceDashGroupsServices';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentalDataSourcesService extends SubscribeManager<EnvironmentalDataSource[]> {
  private environmentalDataSourcesSubject: BehaviorSubject<EnvironmentalDataSource[]> = new BehaviorSubject<
    EnvironmentalDataSource[]
  >([]);

  private siteId: string | null = null;

  constructor(
    private environmentalDataSourceDashGroupsService: EnvironmentalDataSourceDashGroupsService,
    private apiWithLoaderHelper: APIWithLoaderHelper
  ) {
    super();
  }

  public getEnvironmentalDataSources(): Observable<EnvironmentalDataSource[] | null> {
    return this.environmentalDataSourcesSubject.asObservable();
  }

  public refreshEnvironmentalDataSources(siteId: string): void {
    // Don't do anything!
    if (!siteId || this.siteId === siteId) {
      return;
    }
    this.siteId = siteId;
    this.apiWithLoaderHelper
      .get<EnvironmentalDataSource[]>(URLConstants.getEnvironmentalDataSources(siteId), {}, false)
      .pipe(take(1))
      .subscribe((dataSources) => {
        localStorage.setItem('environmentalDataSources', JSON.stringify(dataSources));
        this.environmentalDataSourcesSubject.next(dataSources);
        this.environmentalDataSourceDashGroupsService.setEnvironmentalDataSourceDashGroups(
          dataSources.reduce(
            (groups: string[], dataSource) => [
              ...groups,
              ...(dataSource.dash_groupings?.filter((group) => !groups.includes(group)) ?? []),
            ],
            []
          )
        );
        this.pushChange(dataSources);
      });
  }

  public clearEnvironmentalDataSources(): Observable<null> | null {
    localStorage.removeItem('environmentalDataSources');
    this.environmentalDataSourceDashGroupsService.clearEnvironmentalDataSourceDashGroups();
    this.environmentalDataSourcesSubject.next([]);
    return null;
  }
}
